import script from "./RecordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordPage.vue?vue&type=script&setup=true&lang=js"

import "./RecordPage.vue?vue&type=style&index=0&id=748c6e75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748c6e75"]])

export default __exports__